<div class="scroll-indicator" (click)="scrollPage()" [class.at-bottom]="isAtBottom" [attr.aria-label]="isAtBottom ? 'Scroll to top' : 'Scroll to bottom'" role="button" tabindex="0">
    <i class="fas" [class.fa-arrow-down]="!isAtBottom" [class.fa-arrow-up]="isAtBottom"></i>
</div>

<style>
    .scroll-indicator {
        position: fixed;
        bottom: 20px;
        right: 20px;
        background-color: rgba(170, 205, 235, 0.8);
        padding: 10px;
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.3s ease;
    }
    .scroll-indicator:hover {
        background-color: #FDD235;
    }
    .scroll-indicator i {
        font-size: 24px;
    }
</style>
<div>
    <div>
        <div class="col-md-12 mx-auto text-center">
            <h1> {{language.examPlatformUsageInst}}</h1>
        </div>
        <div>
            <p>{{language.useSafeExamBrowser}}</p>
            <p>{{language.ifInstalledSebTakeYourExam}} <a style="font-weight: 500;" [href]="this.sebExamLaunchUrl"> {{language.clickHereToTakeYourExam}}</a></p>
            <p>{{language.installSebIfNotInstalled}} </p>
            
            
            <div class="nav-tabs-navigation">
                <div class="nav-tabs-wrapper">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'windows'" (click)="activeTab = 'windows'" role="tab" 
                            [attr.aria-selected]="activeTab === 'windows'" aria-controls="windowsTab" id="windowsTabButton"
                                [style.backgroundColor]="activeTab === 'windows' ? '#AACDEB' : ''"
                                style="cursor: pointer; transition: all 0.3s ease;" 
                                onmouseover="this.style.backgroundColor = this.classList.contains('active') ? '#AACDEB' : '#FDD235'" 
                                onmouseout="this.style.backgroundColor = this.classList.contains('active') ? '#AACDEB' : ''">Windows</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'mac'" (click)="activeTab = 'mac'" role="tab"
                             [attr.aria-selected]="activeTab === 'mac'" aria-controls="macTab" id="macTabButton"
                                [style.backgroundColor]="activeTab === 'mac' ? '#AACDEB' : ''"
                                style="cursor: pointer; transition: all 0.3s ease;"
                                onmouseover="this.style.backgroundColor = this.classList.contains('active') ? '#AACDEB' : '#FDD235'"
                                onmouseout="this.style.backgroundColor = this.classList.contains('active') ? '#AACDEB' : ''">Mac OS</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane" [class.active]="activeTab === 'windows'" role="tabpanel" aria-labelledby="windowsTabButton" id="windowsTab">
                            <div class="row">
                                <div class="col-lg-12 col-md-12">
                                    <ol>
                                        <li><a href="{{this.sebDownloadLinkForWindows}}">{{language.clickToDownloadSEB}} (v{{sebCurrentWindowsVersion}})</a></li>
                                        <li>{{language.installTheSoftware}}</li>
                                        <li>{{language.grantSebAllPermissions}}</li>
                                        <li><a [href]="this.sebExamLaunchUrl">{{language.clickHereToTakeYourExam}}</a></li>
                                        <li>{{ language.ifInstallationOrStartupOfSEBFails }}:
                                            <ul>
                                                <li><b>{{ language.disableOrUninstallYourAntivirus }}:</b>&nbsp; {{ language.reasonToDisableAntivirusesForSEB }}</li>
                                                <li><b>{{ language.downloadAndInstallVisualCPP }}:</b>&nbsp; <a href="https://download.visualstudio.microsoft.com/download/pr/7ebf5fdb-36dc-4145-b0a0-90d3d5990a61/CC0FF0EB1DC3F5188AE6300FAEF32BF5BEEBA4BDD6E8E445A9184072096B713B/VC_redist.x64.exe">{{ language.clickHereToDownloadVisualCPP }}</a></li>
                                                <li><b>{{ language.downloadAndInstallDotNetFramework }}:</b>&nbsp; <a href="https://go.microsoft.com/fwlink/?linkid=2088631">{{ language.clickHereToDownloadAndInstallDotNetFramework }}</a></li>
                                                <li><b>{{ language.updateYourOperatingSystem }}:</b>&nbsp; {{ language.instructionsToUpdateOperatingSystem }}</li>
                                            </ul>
                                            <p></p>
                                            {{ language.afterTakingTroubleshootingStepsTryReinstallingOrUsingSEB }}
                                        </li>
                                    </ol>
                                    <p>{{language.furtherInstallationAssistanceneeded}}</p>
                                    <iframe width="100%" height="450" 
                                        src="https://www.youtube.com/embed/CUI01HHjIr0?&rel=0&playlist=CUI01HHjIr0&loop=1"
                                        title="Safe Exam Browser Instructions" 
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen>
                                    </iframe>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" [class.active]="activeTab === 'mac'" role="tabpanel" aria-labelledby="macTabButton" id="macTab">
                            <div class="row">
                                <div class="col-lg-12 col-md-12">
                                    <ol>
                                        <li><a href="{{this.sebDownloadLinkForMac}}">{{language.clickToDownloadSEB}} (v{{setCurrentMacVersion}})</a></li>
                                        <li>{{language.installTheSoftware}}</li>
                                        <li>{{language.grantSebAllPermissions}}</li>
                                        <li><a [href]="this.sebExamLaunchUrl">{{language.clickHereToTakeYourExam}}</a></li>
                                    </ol>
                                    
                                    <p>{{language.furtherInstallationAssistanceneeded}}</p>
                                    <iframe width="100%" height="450" 
                                        src="https://www.youtube.com/embed/U3agv_MdXTo?&rel=0&playlist=U3agv_MdXTo&loop=1" 
                                        title="Safe Exam Browser Instructions" 
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen>
                                    </iframe>
                                </div>
                            </div>
                        </div>
                        <hr class="my-4" style="border-top: 2px solid #ccc;">
                        <p><b>NOTES:</b></p>
                        <ol>
                            <li>{{language.ifDirectStartLinkDoesNotWOrk}}<a [href]="this.sebConfigDownldoadUrl" download><b>{{language.here}}</b></a> {{language.downloadSEBexamfileforyourexam}}
                                {{language.youshouldseefile}}:
                                <div style="margin-top: 5px;">
                                    <img src="/assets/images/SEB_5.png" alt="SEB download example" />
                                </div>
                                <p>{{language.double_clickdownloadedfile}}</p>
                            </li>
                            <li>
                            {{language.confirmInstallSafeExamBrowser}}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>